export { MultiWidget } from './multi-widget';
export { HtmlMultiWidget } from './html-multi-widget';
export { HtmlWidget } from './html-widget';
export { Configuration, PAYMENT_TYPE, PURPOSE } from './configuration';
export { STYLABLE_ELEMENT, STYLABLE_ELEMENT_STATE } from './style';
/**
 * Interface for PayPal checkout meta information
 * @interface IPayPalMeta
 *
 * @param {string} [brand_name] A label that overrides the business name in the PayPal account on the PayPal hosted checkout pages
 * @param {string} [cart_border_color] The HTML hex code for your principal identifying color
 * @param {string} [reference] Merchant Customer Service number displayed on the PayPal pages
 * @param {string} [email] The consumer’s email
 * @param {string} [hdr_img] URL for the image you want to appear at the top left of the payment page
 * @param {string} [logo_img] A URL to your logo image
 * @param {string} [pay_flow_color] Sets the background color for the payment page. By default, the color is white.
 * @param {string} [first_name] The consumer’s given names
 * @param {string} [last_name] The consumer’s surname
 * @param {string} [address_line] Street address
 * @param {string} [address_line2] Second line of the address
 * @param {string} [address_city] City
 * @param {string} [address_state] State
 * @param {string} [address_postcode] Postcode
 * @param {string} [address_country] Country
 * @param {string} [phone] The consumer’s phone number in E.164 international notation (Example: +12345678901)
 * @param {boolean} [hide_shipping_address] Determines whether PayPal displays shipping address fields on the PayPal pages
 */
/**
 * Interface for classes that represent widget's styles.
 * @interface IStyles
 *
 * @param {string} [background_color]
 * @param {string} [text_color]
 * @param {string} [border_color]
 * @param {string} [button_color]
 * @param {string} [error_color]
 * @param {string} [success_color]
 * @param {string} [font_size]
 * @param {string} [font_family]
 */
/**
 * Interface for classes that represent widget's text.
 * @interface ITexts
 *
 * @param {string} [title]
 * @param {string} [title_h1]
 * @param {string} [title_h2]
 * @param {string} [title_h3]
 * @param {string} [title_h4]
 * @param {string} [title_h5]
 * @param {string} [title_h6]
 * @param {string} [finish_text]
 * @param {string} [title_description]
 * @param {string} [submit_button]
 * @param {string} [submit_button_processing]
 * */
/**
 * Current constant include available type of fields which can be included to widget
 * @const FORM_FIELD
 * @type {object}
 * @param {string} CARD_NAME=card_name
 * @param {string} CARD_NUMBER=card_number
 * @param {string} EXPIRE_MONTH=expire_month
 * @param {string} EXPIRE_YEAR=expire_year
 * @param {string} CARD_CCV=card_ccv
 * @param {string} ACCOUNT_NAME=account_name
 * @param {string} ACCOUNT_BSB=account_bsb
 * @param {string} ACCOUNT_NUMBER=account_number
 * @param {string} ACCOUNT_ROUTING=account_routing
 * @param {string} ACCOUNT_HOLDER_TYPE=account_holder_type
 * @param {string} ACCOUNT_BANK_NAME=account_bank_name
 * @param {string} ACCOUNT_TYPE=account_type
 * @param {string} FIRST_NAME=first_name
 * @param {string} LAST_NAME=last_name
 * @param {string} EMAIL=email
 * @param {string} PHONE=phone
 * @param {string} PHONE2=phone2
 * @param {string} ADDRESS_LINE1=address_line1
 * @param {string} ADDRESS_LINE2=address_line2
 * @param {string} ADDRESS_STATE=address_state
 * @param {string} ADDRESS_COUNTRY=address_country
 * @param {string} ADDRESS_CITY=address_city
 * @param {string} ADDRESS_POSTCODE=address_postcode
 * @param {string} ADDRESS_COMPANY=address_company
 * */
/**
 * List of available style params for widget
 *
 * @const STYLE
 * @type {object}
 * @param {string} BACKGROUND_COLOR=background_color
 * @param {string} TEXT_COLOR=text_color
 * @param {string} BORDER_COLOR=border_color
 * @param {string} BUTTON_COLOR=button_color
 * @param {string} ERROR_COLOR=error_color
 * @param {string} SUCCESS_COLOR=success_color
 * @param {string} FONT_SIZE=font_size
 * @param {string} FONT_FAMILY=font_family
 */
/**
 * List of available text item params for widget
 *
 * @const TEXT
 * @type {object}
 * @param {string} TITLE=title
 * @param {string} FINISH=finish_text
 */
/**
 * List of available params for hide elements
 *
 * @const ELEMENT
 * @type {object}
 * @param {string} SUBMIT_BUTTON=submit_button
 * @param {string} TABS=tabs
 */
/**
 * The list of available parameters for showing card icons
 * @const SUPPORTED_CARD_TYPES
 * @type {object}
 * @param {string} AMEX=amex
 * @param {string} AUSBC=ausbc
 * @param {string} DINERS=diners
 * @param {string} DISCOVER=discover
 * @param {string} JAPCB=japcb
 * @param {string} LASER=laser
 * @param {string} MASTERCARD=mastercard
 * @param {string} SOLO=solo
 * @param {string} VISA=visa
 * @param {string} VISA_WHITE=visa_white
 */
//# sourceMappingURL=../../src/lib/widget/index.js.map